<lib-validation-problems [saving$]="saving$"></lib-validation-problems>

<div>
    @if (order.landTitleSearchCriteria?.titleNumber) {
        <div class="flex-container margin-top-15">
            <div class="flex-item-3">{{ 'orders.titleNumber' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.titleNumber }}</div>
        </div>
    }
    @if (order.landTitleSearchCriteria?.legalDescriptionTypeID) {
        <div class="flex-container margin-top-15">
            <div class="flex-item-3">{{ 'orders.legalDescription' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.legalDescriptionTypeID | enumLabel:'legalDescriptionType' }}</div>
        </div>
        @if (order.landTitleSearchCriteria?.legalDescriptionTypeID === 'Rural') {
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showLegalSubdivision) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.legalSubdivision' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.legalSubdivision }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showQuarter) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.quarter' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.quarter }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showSection) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.section' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.section }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showTownship) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.township' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.township }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showRange) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.range' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.range }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showMeridian) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.meridian' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.meridian }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showExtension) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.extension' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.extension }}</div>
        </div>
        }
        } @else if (order.landTitleSearchCriteria?.legalDescriptionTypeID === 'Urban') {
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showPlan) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.plan' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.plan }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showBlockOrUnit) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.blockUnit' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.blockOrUnit }}</div>
        </div>
        }
        @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.legalDescriptionUIConfiguration?.showLot) {
        <div class="flex-container">
            <div class="flex-item-3">{{ 'orders.lot' | transloco }}</div>
            <div class="flex-item-4">{{ order.landTitleSearchCriteria!.lot }}</div>
        </div>
        }
        }
    }
    @if (uiConfiguration.landTitleSearchCriteriaConfiguration?.showAddress && address) {
        <div class="flex-container margin-top-15">
            <div class="flex-item-3">{{ 'orders.civicAddress' | transloco }}</div>
            <div class="flex-item-4">{{ address }}</div>
        </div>
    }
</div>

@if (order.landTitleSearchCriteria?.party) {
<div>
    <h4 class="margin-bottom-5">{{ 'orders.debtor' | transloco }}</h4>
    <lib-parties-list partyTypeTitle="Debtor" [order]="order" [observableParties$]="party" [isEditable]="false"> </lib-parties-list>
</div>
}